export default __webpack_public_path__ + "static/media/tenor.f119d1eb.png";